<template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
  /* eslint-disable @typescript-eslint/camelcase */
  import { mapGetters } from 'vuex';
  import { ToggleButton } from 'vue-js-toggle-button';
  import { ROUTE_TYPES } from '@/utils';
  import {    ACTION_TYPES } from '@/constants';
  import Navbar from '@/components/Navbar';
import ProgressBar from '@/components/ProgressBar';
  import { Q_PHONE_NUMBERS, M_SET_TEXT_FLOW_TO_MENU, M_SET_TEXT_FLOW_TO_PERSON, M_SET_TEXT_FLOW_TO_GROUP, M_SET_TEXT_FLOW_TO_NOASSIGN, M_ONBOARDING_STEP } from '@/graphql';
  import BackButton from '@/components/BackButton';
  import TextFlowNumber from '@/components/TextFlowNumber';
  import CustomButton from '@/components/CustomButton';
  import TextRoutePerson from './TextRoutePerson';
  import TextMenu from './TextMenu';
  import Background from '@/components/Background';
  export default {
    name: 'TextComponent',
    computed: {
      ...mapGetters({
        groups: 'auth/getUserGroups',
        users: 'auth/getUsers',
   
        phoneName: 'onboarding/getSelectedName',
         myUser: 'auth/getUser',
      phoneNumber: 'onboarding/getSelectedNumber',
      phoneId: 'onboarding/getSelectedId',
      }),
   

      smsType() {
        const { textflow } = this.phoneNumber;
      

    
       if(textflow)
          {
   
   
   
            return textflow.user_id
          ? ROUTE_TYPES.ROUTE_PERSON
          : textflow.group_id
            ? ROUTE_TYPES.ROUTE_GROUP
            : textflow.keyword_routing
              ? ROUTE_TYPES.ROUTE_MENU
              : null;
          }
          else
          {
                    return null;

          }

        
      },
     
      touched() {







        if (this.enabled) {
       
       
       
       
       
          let noEnabled = [];
          let noPrev = []

          if (this.target.length > 0) {
            noEnabled = this.target;



          }
          if (this.previous.target.length > 0) {
            noPrev = this.previous.target;
          }

          if (noEnabled.filter(e => !e.isEnabled).length == 0) {
            return false;
          }

          if (noEnabled.filter(e => !e.isEnabled)[0].routingType == "choose") 
          { return false; }
                                                             console.log(noEnabled)
                 

          if ( (this.previous.autoReply  &&  (this.previous.autoReply.enabled !== this.autoReply.enabled) )   ||          ( this.previous.autoReply       &&                   (this.previous.autoReply.replyText !== this.autoReply.replyText) )  || JSON.stringify(noEnabled) != JSON.stringify(noPrev)) {




            if (this.target.length > 0) {




              let isEnabled = true;

              this.target.filter(e => !e.isEnabled).forEach(e => {
                if (e.keywords.length == 0) {
                  isEnabled = false
                }


              })





              return isEnabled;

            }




          }
        }

        else {


          
          console.log(this.type)
          if (this.previous.type == this.type) {
            if (this.previous.type == "person") {
              if (this.previous.user.id != this.user.id) {
                return true;

              }

            }

          }
          else {
            if (this.type != "") {
              return true;


            }


          }



          return false;

        }


        if (this.target.length > 0) {

          const current = this.target.filter(e => e.isEnabled)
          if (!this.autoReply.enabled) {
            if (current.length > 0) {
              if (JSON.stringify(this.target) != JSON.stringify(this.previous.target)) {
                return true;

              }

            }


          }



        }

        return false;






      }


    },
    mounted() {
      this.previous.type = this.smsType;


    }
    ,
    components: {
      Navbar,
    ProgressBar,
      BackButton,
      TextFlowNumber,
      ToggleButton,
      TextRoutePerson,
      TextMenu,
      CustomButton,
      Background,
    },

    created() {

      const { textflow } = this.phoneNumber;
           if(!textflow)
           {
            this.enabled = false;
           }
           else
           {
            
      if (!textflow.user_id) {

if (!textflow.group_id) {
  if (textflow.keyword_routing) {
    this.enabled = true

  }



}


}


           }


    },

    data() {
      return {
        enabled: false,
        previous: {
          type: "",
          user: {},
          target: {},
          group: {},
          enabled: false,
          autoReply: {
            enabled: false,
            replyText: ''
          },
        },
        user: {},
        clicked: -1,
        type: "",
        target: {},
        group: {},
        onDetail: false,
        onText: false,
        contas: false,
        autoReply: {
          enabled: false,
          replyText: ''
        },
      };
    },
    methods: {
      handleToggle() {
        this.enabled = !this.enabled;
        this.previous.enabled = this.enabled;
      },
      async onClick() {


        if (!this.enabled) {

          if (this.type == "person") {

            try {
              // disable button
            

              // send mutation request if different user is selected
              await this.$apollo.mutate({
                mutation: M_SET_TEXT_FLOW_TO_PERSON,
                variables: {
                  phoneNumberId:    this.phoneId,
                  userId: this.user.id
                },
                update: async (cache, { data: { update_textflows } }) => {
                  try {
                 this.previous.type = this.type;
                    this.previous.user = this.user;
                    this.previous.id = this.id;
                    this.previous.group = this.group;
            
                    await this.$apollo.mutate({
          mutation: M_ONBOARDING_STEP,
          variables: {
            user_id: this.myUser.id,
            onboarding_step: 5
          }
        });
        await this.$store.dispatch('onboarding/setOnboardingStep', 5);
        // enable the Next button
        this.isLoading = false;

        return await this.$router.push('/onboarding-mobile');

                
                  } catch (e) {
                    console.log(e);
                  }
                }
              });


            } catch (error) {

              return console.log('SMS ROUTING -> USERS: ERROR\n', error);
            }


          }
          else {
            if (this.type == "group") {
              try {
                // send mutation request if different user is selected
                await this.$apollo.mutate({
                  mutation: M_SET_TEXT_FLOW_TO_GROUP,
                  variables: {
                    phoneNumberId:  this.phoneId,
                    groupId: this.group.id
                  },
                  update:                                   async   (cache, { data: { update_textflows } }) => {
                    try {
                        this.previous.type = this.type;
                      this.previous.user = this.user;
                      this.previous.id = this.id;
                      this.previous.group = this.group;
                      await this.$apollo.mutate({
          mutation: M_ONBOARDING_STEP,
          variables: {
            user_id: this.myUser.id,
            onboarding_step: 5
          }
        });
        await this.$store.dispatch('onboarding/setOnboardingStep', 5);
        // enable the Next button
        this.isLoading = false;

        return await this.$router.push('/onboarding-mobile');
     
               
                    } catch (e) {
                      console.log(e);
                    }
                  }
                });

                // enable the Next button
                this.isLoading = false;
              } catch (error) {
                this.isLoading = false;
                return console.log('SMS ROUTING -> GROUPS: ERROR\n', error);
              }

            }

            else {


              if (this.type == "noassign") {

                try {
                  // disable button


                  // send mutation request if different user is selected
                  await this.$apollo.mutate({
                    mutation: M_SET_TEXT_FLOW_TO_NOASSIGN,
                    variables: {
                      phoneNumberId:  this.phoneId,

                    },
                    update: async (cache, { data: { update_textflows } }) => {
                      try {
         this.previous.type = this.type;
                        this.previous.user = this.user;
                        this.previous.id = this.id;
                        this.previous.group = this.group;
                        await this.$apollo.mutate({
          mutation: M_ONBOARDING_STEP,
          variables: {
            user_id: this.myUser.id,
            onboarding_step: 5
          }
        });
        await this.$store.dispatch('onboarding/setOnboardingStep', 5);
        // enable the Next button
        this.isLoading = false;

        return await this.$router.push('/onboarding-mobile');

                
                      } catch (e) {
                        console.log(e);
                      }
                    }
                  });


                } catch (error) {

                  return console.log('SMS ROUTING -> USERS: ERROR\n', error);
                }


              }



            }

          }


        }
        else {
          try {
       
       
            const textMenu = {
              routes: this.formatRoutes(),
              auto_reply: this.autoReply.enabled,
              reply_msg: this.autoReply.replyText
            };
      
            


            this.previous.target = JSON.parse(JSON.stringify(this.target))
            this.previous.autoReply = JSON.parse(JSON.stringify(this.autoReply))


            await this.$apollo.mutate({
              mutation: M_SET_TEXT_FLOW_TO_MENU,
              variables: {
                phoneNumberId:  this.phoneId,
                textMenu: JSON.stringify(textMenu)
              },
              update: async (cache, { data: { update_textflows } }) => {
   
    
                this.previous.type = this.type;
                        this.previous.user = this.user;
                        this.previous.id = this.id;
                        this.previous.group = this.group;
                await this.$apollo.mutate({
          mutation: M_ONBOARDING_STEP,
          variables: {
            user_id: this.myUser.id,
            onboarding_step: 5
          }
        });
        await this.$store.dispatch('onboarding/setOnboardingStep', 5);
        // enable the Next button
        this.isLoading = false;

        return await this.$router.push('/onboarding-mobile');

                try {

                } catch (e) {
                  console.log(e);
                }
              }
            });


          } catch (error) {

            console.log('SMS ROUTING -> MENU: ERROR\n', error);
          }



        }
      },
      isDetail() {
        alert("s")



      },
      noDisplay(e) {
        if (!(e.target.className.indexOf("noTarget") > 0)) {
          this.clicked = Date.now();
        }



      },
      setsUsers(user) {
        this.user = user;

      },
      setsTexts(isText, data) {
        if (isText) {

          this.autoReply.replyText = data;
        }
        else {
          this.autoReply.enabled = data;



        }

      },
      setsTarget(data) {
        this.target = data;
      },

      prevTexts(isText, data) {

        if (isText) {

          this.previous.autoReply.replyText = data;
        }
        else {
          this.previous.autoReply.enabled = data;



        }

      },
      prevTarget(data) {
        this.previous.target = data;
      },



      formatRoutes() {


   

        const formatted = this.target.map((route) => {
          return {
            keywords: route.keywords,
            user_id: route.routingType === ACTION_TYPES.ACTION_PERSON ? route.target.id : null,
            group_id: route.routingType === ACTION_TYPES.ACTION_GROUP ? route.target.id : null
          };
        });
        return formatted;
      },



      setsTypes(type) {
        this.type = type;

      },
      setsgroup(group) {
        this.group = group;

      },



    }




  };
</script>

